import webvitals from "../../../../assets/images/docs/webvitals/popup.png";
import inpattribution from "../../../../assets/images/docs/inp-attribution.png";
import * as React from 'react';
export default {
  webvitals,
  inpattribution,
  React
};